export default {"src":"/_next/static/media/card_companies.1980a08f.svg","height":222,"width":302,"blurWidth":0,"blurHeight":0};